<template>
  <div
    ref="kt_modal_faturamento_importacao_pedido_venda"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade"
    tabindex="-1"
    id="kt_modal_faturamento_importacao_pedido_venda"
    data-bs-keyboard="false"
    v-modal-drag
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen005.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">
              Importação Pedido de Venda
            </h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div class="d-flex flex-wrap flex-sm-nowrap mb-3">
              <div class="flex-grow-1">
                <div class="d-flex align-items-center position-relative my-1">
                  <span class="svg-icon svg-icon-1 position-absolute ms-6">
                    <inline-svg src="media/icons/duotune/general/gen004.svg" />
                  </span>
                  <input
                    id="txtPesquisarPedidos"
                    type="text"
                    v-model="tableData.search"
                    @input="onSearch($event.target.value)"
                    class="form-control form-control-solid w-225px ps-15"
                    placeholder="Pesquisar Pedidos"
                  />
                </div>
              </div>
              <div class="p-2">
                <div
                  class="form-check form-switch form-check-custom form-check-solid"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    @change="
                      this.apenasClienteAtual = $event.target.checked
                        ? true
                        : false;
                      this.loadData();
                    "
                    id="chkApenasClienteSelecionado"
                    :checked="this.apenasClienteAtual === true"
                  />
                  <label
                    class="form-check-label"
                    for="chkApenasClienteSelecionado"
                  >
                    Apenas o cliente atual
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <Datatable
              ref="table"
              :table-header="tableHeader"
              :table-data="tableData"
              :table-pagination="tablePagination"
              :page-sizes="pageSizes"
              :enable-items-per-page-dropdown="true"
              :hide-on-single-page="false"
              empty-table-text="Nenhum pedido encontrado"
              @checked-rows="checkedPedidos = $event"
              :colors="true"
            >
              <template v-slot:cell-checkbox="{ row: pedido }">
                <div
                  class="form-check form-check-sm form-check-custom form-check-solid"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :value="pedido.id"
                    v-model="checkedPedidos"
                  />
                </div>
              </template>
              <template v-slot:cell-PedidoClienteClienteFoto="{ row: pedido }">
                <div
                  v-if="
                    pedido.PedidoCliente &&
                    pedido.PedidoCliente.Cliente &&
                    pedido.PedidoCliente.Cliente.foto
                      ? pedido.PedidoCliente.Cliente.foto
                      : ''
                  "
                  class="symbol symbol-50px"
                >
                  <div
                    class="symbol-label fs-2 fw-bold bg-light-dark"
                    :style="{
                      'background-image': `url(${
                        this.$utils.getUrl() + pedido.PedidoCliente.Cliente.foto
                      })`,
                    }"
                  ></div>
                </div>
                <div v-else class="symbol symbol-50px">
                  <div :class="['symbol-label fs-2 fw-bold ' + pedido.color]">
                    {{
                      pedido.PedidoCliente && pedido.PedidoCliente.nome
                        ? pedido.PedidoCliente.nome
                            .substring(0, 1)
                            .toUpperCase()
                        : ""
                    }}
                  </div>
                </div>
              </template>
              <template v-slot:cell-id="{ row: pedido }">
                <div class="text-dark fw-bolder">
                  {{ pedido.id }}
                </div>
              </template>
              <template v-slot:cell-PedidoClienteNome="{ row: pedido }">
                <div class="min-w-150px align-middle">
                  <div>
                    <span class="text-dark text-hover-primary mb-1">
                      {{
                        pedido.PedidoCliente && pedido.PedidoCliente.nome
                          ? pedido.PedidoCliente.nome
                          : ""
                      }}
                    </span>
                    <span class="text-muted fw-bold d-block">
                      {{
                        pedido.PedidoCliente && pedido.PedidoCliente.cpf_cnpj
                          ? pedido.PedidoCliente.cpf_cnpj.length === 11
                            ? this.$utils.setMask(
                                pedido.PedidoCliente.cpf_cnpj,
                                "###.###.###-##",
                                true
                              )
                            : this.$utils.setMask(
                                pedido.PedidoCliente.cpf_cnpj,
                                "##.###.###/####-##",
                                true
                              )
                          : ""
                      }}
                    </span>
                  </div>
                </div>
              </template>
              <template v-slot:cell-situacao="{ row: pedido }">
                <span
                  :class="[
                    pedido.situacao
                      ? this.getSituacaoColor(pedido.situacao)
                      : '',
                  ]"
                  >{{ pedido.situacao }}</span
                >
              </template>
              <template v-slot:cell-total="{ row: pedido }">
                <div class="text-dark fw-bolder align-middle min-w-100px">
                  R$ {{ this.$utils.formatarNumero(pedido.total) }}
                </div>
              </template>
              <template v-slot:cell-data_emissao="{ row: pedido }">
                <div class="min-w-100px">
                  {{ this.$utils.formatarData(pedido.data_emissao) }}
                </div>
              </template>
              <template v-slot:cell-data_saida="{ row: pedido }">
                <div class="min-w-100px">
                  {{ this.$utils.formatarData(pedido.data_entrega) }}
                </div>
              </template>
              <template v-slot:cell-tipo="{ row: pedido }">
                <span
                  :class="[pedido.tipo ? this.getTipoColor(pedido.tipo) : '']"
                  >{{ pedido.tipo }}</span
                >
              </template>
              <template v-slot:cell-acoes="{ row: pedido }">
                <div class="min-w-200px">
                  <button
                    class="btn btn-sm btn-secondary btn-icon-gray-900 me-2"
                    @click="importarPedido(pedido)"
                  >
                    <span class="svg-icon svg-icon-1">
                      <inline-svg
                        src="media/icons/duotune/arrows/arr037.svg"
                        class="me-2"
                      />Importar
                    </span>
                  </button>
                </div>
              </template>
            </Datatable>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            @click="importarPedidosSelecionados()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
            v-if="this.checkedPedidos.length > 0"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import { mapState } from "vuex";

export default {
  emits: ["exibirModalImportarPedidoVenda", "importarPedidoVenda"],
  components: {
    Datatable,
  },
  props: {
    cliente: { type: Number, required: false, default: 0 },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    async importarPedido(pedido) {
      this.loading = true;
      await this.$swal.showQuestionAlert(
        "Deseja importar o pedido " + pedido.id + "?",
        (alert) => {
          if (alert.isConfirmed) {
            this.$emit("importarPedidoVenda", pedido.id, true);

            hideModal(this.$refs.kt_modal_faturamento_importacao_pedido_venda);
            this.$emit("exibirModalImportarPedidoVenda", false);
          }
        }
      );
      this.loading = false;
    },

    async importarPedidosSelecionados() {
      this.loading = true;
      await this.$swal.showQuestionAlert(
        "Deseja importar os pedidos selecionados?",
        (alert) => {
          if (alert.isConfirmed) {
            for (let i = 0; i <= this.checkedPedidos.length; i++) {
              this.$emit("importarPedidoVenda", this.checkedPedidos[i], false);
            }

            hideModal(this.$refs.kt_modal_faturamento_importacao_pedido_venda);
            this.$emit("exibirModalImportarPedidoVenda", false);
          }
        }
      );
      this.loading = false;
    },

    cancelar() {
      hideModal(this.$refs.kt_modal_faturamento_importacao_pedido_venda);
      this.$emit("exibirModalImportarPedidoVenda", false);
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    loadData() {
      this.tableData.search = "";
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 10;
      this.$refs.table.setRowsPage(10);

      this.tableData.filterOData = "&$filter=situacao ne 'Faturado'";

      if (this.apenasClienteAtual === true && this.cliente > 0) {
        this.tableData.filterOData +=
          "and PedidoCliente/id_cliente eq " + this.cliente;
      }

      this.$refs.table.load();
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData = "&$filter=situacao ne 'Faturado' and ";

        if (this.apenasClienteAtual === true && this.cliente > 0) {
          this.tableData.filterOData +=
            "PedidoCliente/id_cliente eq " + this.cliente + " and ";
        }

        this.tableData.filterOData +=
          "(contains(situacao, '" +
          pesquisa +
          "') or contains(tipo, '" +
          pesquisa +
          "') or contains(PedidoCliente/nome, '" +
          pesquisa +
          "') or contains(PedidoCliente/cpf_cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData += " or id eq " + pesquisa;
        }

        this.tableData.filterOData += ")";
      } else {
        if (this.apenasClienteAtual === true && this.cliente > 0) {
          this.tableData.filterOData =
            "&$filter=PedidoCliente/id_cliente eq " + this.cliente;
        } else {
          this.tableData.filterOData = "";
        }
      }
    },
    getSituacaoColor(situacao) {
      if (situacao.toUpperCase() === "FATURADO") {
        return "badge badge-light-success text-success";
      } else if (situacao.toUpperCase() === "ATRASADO") {
        return "badge badge-light-danger text-danger";
      } else if (situacao.toUpperCase() === "ENTREGUE") {
        return "badge badge-light-info text-info";
      } else if (situacao.toUpperCase() === "PENDENTE") {
        return "badge badge-light-primary text-primary";
      } else {
        return "badge badge-light-dark text-dark";
      }
    },
    getTipoColor(tipo) {
      if (tipo.toUpperCase() === "DELIVERY") {
        return "badge badge-light-info text-info";
      } else if (tipo.toUpperCase() === "AGENDAMENTO") {
        return "badge badge-light-warning text-warning";
      } else if (tipo.toUpperCase() === "RETIRADA") {
        return "badge badge-light-primary text-primary";
      } else {
        return "badge badge-light-dark text-dark";
      }
    },
  },
  mounted() {
    this.errosValidacao = {};
    this.apenasClienteAtual = this.cliente > 0 ? true : false;
    this.loadData();
    this.$utils.requestFocus("txtPesquisarPedidos");
  },
  data() {
    return {
      errosValidacao: [],
      loading: false,
      checkedPedidos: [],
      apenasClienteAtual: true,
      tableHeader: [
        {
          type: "checkbox",
          key: "checkbox",
          sortable: false,
        },
        {
          key: "PedidoClienteClienteFoto",
          sortingField: "PedidoCliente/Cliente/foto",
          sortable: false,
        },
        {
          name: "Número Pedido",
          key: "id",
          sortable: true,
        },
        {
          name: "Cliente",
          key: "PedidoClienteNome",
          sortingField: "PedidoCliente/nome",
          sortable: true,
        },
        {
          name: "Situação",
          key: "situacao",
          sortable: true,
        },
        {
          name: "Total",
          key: "total",
          sortable: true,
        },
        {
          name: "Emissão",
          key: "data_emissao",
          sortable: true,
        },
        {
          name: "Tipo",
          key: "tipo",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableHeaderModal: [
        {
          name: "Número Pedido",
          key: "id",
          sortable: true,
        },
        {
          key: "PedidoClienteClienteFoto",
          sortingField: "PedidoCliente/Cliente/foto",
          sortable: false,
        },
        {
          name: "Cliente",
          key: "PedidoClienteNome",
          sortingField: "PedidoCliente/nome",
          sortable: true,
        },
        {
          name: "Situação",
          key: "situacao",
          sortable: true,
        },
        {
          name: "Total",
          key: "total",
          sortable: true,
        },
        {
          name: "Emissão",
          key: "data_emissao",
          sortable: true,
        },
        {
          name: "Saída/Entrega",
          key: "data_entrega",
          sortable: true,
        },
        {
          name: "Tipo",
          key: "tipo",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "pedido/getPedidoOData",
        selectOData:
          "?$select=id,situacao,total,data_emissao, data_entrega,tipo&$expand=PedidoCliente($select=nome,cpf_cnpj;expand=Cliente($select=foto))&$orderby=id desc",
        filterOData: "",
        search: "",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50"],
    };
  },
};
</script>

<style></style>
